import {
  CUSTOM_PROPERTY_STATUS_SET,
  getCustomPropertyStatusLabel,
} from './customPropertyStatuses';

const LISTING_STATUSES = new Set([
  'active',
  'pending',
  'sold',
  'withdrawn',
  'expired',
  'unknown',
]);

export const LISTING_STATUS_LABELS = {
  active: 'Active',
  pending: 'Pending',
  sold: 'Sold',
  withdrawn: 'Withdrawn',
  expired: 'Expired',
  unknown: 'Unknown status',
};

/**
 * Resolve chip status for display. Manual custom property status wins until
 * MLS sync provides a normalized status other than unknown.
 */
export function resolveListingDisplayStatus({
  customPropertyStatus = null,
  mlsStatus = 'unknown',
  mlsSyncEnabled = false,
}) {
  const normalizedMls = LISTING_STATUSES.has(mlsStatus) ? mlsStatus : 'unknown';

  if (mlsSyncEnabled && normalizedMls !== 'unknown') {
    return {
      status: normalizedMls,
      statusLabel: LISTING_STATUS_LABELS[normalizedMls],
      statusSource: 'mls',
      mlsStatus: normalizedMls,
      customPropertyStatus: null,
    };
  }

  const customRaw = customPropertyStatus
    ? String(customPropertyStatus).trim()
    : '';
  if (customRaw && CUSTOM_PROPERTY_STATUS_SET.has(customRaw)) {
    return {
      status: customRaw,
      statusLabel: getCustomPropertyStatusLabel(customRaw),
      statusSource: 'custom',
      mlsStatus: normalizedMls,
      customPropertyStatus: customRaw,
    };
  }

  return {
    status: normalizedMls,
    statusLabel: LISTING_STATUS_LABELS[normalizedMls],
    statusSource: normalizedMls === 'unknown' ? 'unknown' : 'mls',
    mlsStatus: normalizedMls,
    customPropertyStatus: null,
  };
}

export { LISTING_STATUSES };
